module.exports = __webpack_public_path__ + "static/media/Charles E. Hughes - 1916.adf8b53a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Charles E. Hughes - 1916.jpg
// module id = 450
// module chunks = 0